import { ReactNode } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from './AuthContext';
import LogoMark from '../LogoMark';

export default function LoginGate({ children }: { children: ReactNode }) {
  const { status, authError, signInWithGoogle } = useAuth();
  if (status === 'authed') return <>{children}</>;
  // While the boot refresh is in flight, render nothing rather than flashing sign-in.
  if (status === 'loading') return null;
  return (
    <main
      className="flex min-h-screen items-center justify-center bg-page px-8 py-8
                 bg-[radial-gradient(120%_70%_at_50%_-10%,#f7faec_0%,#edf1da_45%,#d6deb4_100%)]
                 font-trirong_light text-gray-800"
    >
      <section className="w-full max-w-[416px] rounded-2xl bg-white px-10 py-11 text-center shadow-card">
        <div className="mb-7 flex flex-col items-center gap-2">
          <LogoMark className="h-[44px] w-auto" />
          <span className="font-trirong_reg text-[24px] tracking-[0.015em] text-gray-800">New Dawn Counselling</span>
        </div>

        <h1 className="font-trirong_reg text-[27px] text-lime-700">Welcome back…</h1>
        <p className="mt-1.5 font-trirong_light text-[14.5px] leading-relaxed text-gray-600">
          Sign in to write and manage your blogs.
        </p>

        <div className="mt-7 flex justify-center">
          <GoogleLogin
            // One Tap rides on this single GIS init. Mounting a second One Tap elsewhere
            // calls google.accounts.id.initialize() twice; the singleton keeps only the
            // last, and the live card can't carry click activation to it — so the popup
            // is blocked and sign-in silently does nothing. Keep exactly one init.
            useOneTap
            auto_select
            onSuccess={(resp) => {
              if (resp.credential) signInWithGoogle(resp.credential);
            }}
            onError={() => {}}
          />
        </div>

        {authError ? (
          <p className="mt-6 font-trirong_light text-[13px] text-red-600">{authError}</p>
        ) : (
          <p className="mt-6 font-trirong_light text-[13px] text-meta">
            Only the practice owner can sign in.
          </p>
        )}
      </section>
    </main>
  );
}
